import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import './Faqs.css';

const Faqs = () => {
  return (
    <div className='faqs' id='faqs'>
      <h2 className="faqsTitle">Preguntas frecuentes</h2>
      <div className="accordion faqsAccordion" id="accordionFlushExample">
        <div className="accordion-item">
          <h2 className="accordion-header" id="flush-headingOne">
            <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseOne" aria-expanded="false" aria-controls="flush-collapseOne">
              <b>¿Qué pasa si deseo reprogramar mi turno?</b>
            </button>
          </h2>
          <div id="flush-collapseOne" className="accordion-collapse collapse" aria-labelledby="flush-headingOne" data-bs-parent="#accordionFlushExample">
            <div className="accordion-body text-start">Podés hacerlo desde el mail de confirmación del turno que habías seleccionado. Allí aparece una opción para reprogramar. La misma debe realizarse al menos 24 hs previas al turno.</div>
          </div>
        </div>
        <div className="accordion-item">
          <h2 className="accordion-header" id="flush-headingTwo">
            <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseTwo" aria-expanded="false" aria-controls="flush-collapseTwo">
              <b>¿Qué pasa si deseo cancelar mi turno?</b>
            </button>
          </h2>
          <div id="flush-collapseTwo" className="accordion-collapse collapse" aria-labelledby="flush-headingTwo" data-bs-parent="#accordionFlushExample">
            <div className="accordion-body text-start">Podés realizarlo desde el mail de confirmación del turno que habías seleccionado. Allí aparece una opción para cancelarlo. Se realizará sin costo siempre y cuando la cancelación se realice 24 hs previas, de lo contrario se debe abonar el costo de seña.</div>
          </div>
        </div>
        <div className="accordion-item">
          <h2 className="accordion-header" id="flush-headingThree">
            <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseThree" aria-expanded="false" aria-controls="flush-collapseThree">
              <b>¿Las consultas son únicamente particulares?</b>
            </button>
          </h2>
          <div id="flush-collapseThree" className="accordion-collapse collapse" aria-labelledby="flush-headingThree" data-bs-parent="#accordionFlushExample">
            <div className="accordion-body text-start">Sí, no trabajo a través de obras sociales. Las consultas son particulares, tanto de forma presencial como online.</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Faqs;
